import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableFooter from '@material-ui/core/TableFooter';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from '@material-ui/core/TablePagination';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

import rowsPerPageOptions from 'config/rowsPerPageOptions';

import ClaimStatusesTableEmpty from './ClaimStatusesTableEmpty';
import ClaimStatusesTableRow from './ClaimStatusesTableRow';

const styles = () => ({
  typography: {
    paddingLeft: 10,
    paddingBottom: 8,
  },
  root: {
    width: '100%',
  },
  table: {
    minWidth: 500,
  },
  hiddenCell: {
    fontSize: 0,
  },
  tableHead: {
    position: 'sticky',
    zIndex: 20,
    top: 126,
    '& th:first-child': {
      borderTopLeftRadius: 10,
    },
    '& th:last-child': {
      borderTopRightRadius: 10,
    },
  },
});

const ClaimStatusesTable = ({
  items,
  count,
  page,
  rowsPerPage,
  classes,
  onChangePage,
  onChangeRowsPerPage,
  loading,
}) => (
  <div>
    {(loading === 0 || items.length > 0) && (
      <Typography className={classes.typography}>
        {`(${count})`}
      </Typography>
    )}
    <Paper className={classes.root}>
    {(loading === 0 && items.length === 0) &&
      <ClaimStatusesTableEmpty />
    }
    {items.length > 0 &&
      <Table className={classes.table}>
        <TableHead
          className={classes.tableHead}
        >
          <TableRow>
            <TableCell>Status Name</TableCell>
            <TableCell>Category</TableCell>
            <TableCell className={classes.hiddenCell}>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map(item => (
            <ClaimStatusesTableRow
              key={item.ID}
              {...item}
            />
          ))}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              count={count}
              rowsPerPage={rowsPerPage}
              page={page}
              {...loading === 0 ? {
                onChangePage,
                onChangeRowsPerPage,
              } : {
                onChangePage: () => {},
                onChangeRowsPerPage: () => {},
              }}
              rowsPerPageOptions={rowsPerPageOptions}
            />
          </TableRow>
        </TableFooter>
      </Table>
    }
  </Paper>
  </div>
);

ClaimStatusesTable.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number.isRequired,
  })).isRequired,
  count: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  onChangePage: PropTypes.func.isRequired,
  onChangeRowsPerPage: PropTypes.func.isRequired,
  loading: PropTypes.number,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    table: PropTypes.string.isRequired,
    hiddenCell: PropTypes.string.isRequired,
  }).isRequired,
};

ClaimStatusesTable.defaultProps = {
  loading: 0,
};

export default withStyles(styles)(ClaimStatusesTable);



// WEBPACK FOOTER //
// ./src/components/settings/ClaimStatusesTable/ClaimStatusesTable.js